import React from 'react'

function Download() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8 3.583a.75.75 0 01.75.75v5.523l1.715-1.714a.749.749 0 111.06 1.06L8.53 12.197a.749.749 0 01-1.06 0L4.475 9.202a.744.744 0 01-.22-.53.749.749 0 011.28-.53L7.25 9.856V4.333a.75.75 0 01.75-.75zM8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8z"
                clipRule="evenodd"
            ></path>
        </svg>
    )
}

export default Download
